export default function useImageLayer(level = 2) {
    return {
        style: {
            position: 'relative',
            zIndex: Number.isFinite(level) ? level : 2,
        },
    };
}
